<template>
    <div class="p-3">
        <div
            class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3"
        >
            <div>
                <h3 class="mb-1">File Status Keluar</h3>
                <div class="text-muted">
                    Monitoring dan pengisian status keluar berkas rekam medis.
                </div>
            </div>

            <button
                type="button"
                class="btn btn-danger"
                :disabled="loading"
                @click="printPdf"
            >
                <i class="fa fa-file-pdf-o me-1"></i>
                Print PDF
            </button>
        </div>

        <div class="card border-0 shadow-sm mb-3">
            <div class="card-header bg-white fw-semibold">
                <i class="fa fa-filter text-primary me-1"></i>
                Pencarian Data
            </div>

            <div class="card-body">
                <div class="row g-3">
                    <div class="col-12 col-md-6 col-xl-2">
                        <label class="form-label small fw-semibold text-muted">
                            No. Registrasi
                        </label>

                        <input
                            v-model="filter.Regno"
                            type="text"
                            class="form-control"
                            placeholder="No. Registrasi"
                            :disabled="loading"
                            @keyup.enter="applyFilter"
                        />
                    </div>

                    <div class="col-12 col-md-6 col-xl-2">
                        <label class="form-label small fw-semibold text-muted">
                            No. Rekam Medis
                        </label>

                        <input
                            v-model="filter.Medrec"
                            type="text"
                            class="form-control"
                            placeholder="No. RM"
                            :disabled="loading"
                            @keyup.enter="applyFilter"
                        />
                    </div>

                    <div class="col-12 col-md-6 col-xl-2">
                        <label class="form-label small fw-semibold text-muted">
                            Nama Pasien
                        </label>

                        <input
                            v-model="filter.Firstname"
                            type="text"
                            class="form-control"
                            placeholder="Nama pasien"
                            :disabled="loading"
                            @keyup.enter="applyFilter"
                        />
                    </div>

                    <div class="col-12 col-md-6 col-xl-2">
                        <label class="form-label small fw-semibold text-muted">
                            Poli
                        </label>

                        <select
                            v-model="filter.Poli"
                            class="form-select"
                            :disabled="loadingPoli || loading"
                            @change="onPoliChange"
                        >
                            <option value="">Semua Poli</option>

                            <option
                                v-for="item in poli"
                                :key="item.KDPoli"
                                :value="item.KDPoli"
                            >
                                {{ item.NMPoli }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-6 col-xl-2">
                        <label class="form-label small fw-semibold text-muted">
                            Tanggal Dari
                        </label>

                        <input
                            v-model="filter.date1"
                            type="date"
                            class="form-control"
                            :disabled="loading"
                        />
                    </div>

                    <div class="col-12 col-md-6 col-xl-2">
                        <label class="form-label small fw-semibold text-muted">
                            Tanggal Sampai
                        </label>

                        <input
                            v-model="filter.date2"
                            type="date"
                            class="form-control"
                            :disabled="loading"
                        />
                    </div>
                </div>

                <div class="d-flex flex-wrap gap-2 mt-3">
                    <button
                        type="button"
                        class="btn btn-primary"
                        :disabled="loading"
                        @click="applyFilter"
                    >
                        <span
                            v-if="loading"
                            class="spinner-border spinner-border-sm me-1"
                        ></span>

                        <i v-else class="fa fa-search me-1"></i>

                        Cari
                    </button>

                    <button
                        type="button"
                        class="btn btn-outline-secondary"
                        :disabled="loading"
                        @click="resetFilter"
                    >
                        <i class="fa fa-refresh me-1"></i>
                        Reset
                    </button>
                </div>
            </div>
        </div>

        <div class="card border-0 shadow-sm">
            <div class="card-header bg-white">
                <div
                    class="d-flex flex-wrap align-items-center justify-content-between gap-2"
                >
                    <div class="fw-semibold">
                        <i class="fa fa-folder-open text-primary me-1"></i>
                        Daftar File Status Keluar
                    </div>

                    <div class="d-flex align-items-center gap-2">
                        <span class="small text-muted">Tampilkan</span>

                        <select
                            v-model.number="perPage"
                            class="form-select form-select-sm per-page"
                            :disabled="loading"
                            @change="changePerPage"
                        >
                            <option :value="10">10</option>
                            <option :value="25">25</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>

                        <span class="small text-muted">data</span>
                    </div>
                </div>
            </div>

            <div class="card-body p-0 position-relative">
                <div v-if="loading" class="loading-overlay">
                    <div class="text-center">
                        <div class="spinner-border text-primary"></div>
                        <div class="mt-2 text-muted">Memuat data...</div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table
                        class="table table-bordered table-hover align-middle mb-0"
                    >
                        <thead class="table-light">
                            <tr>
                                <th class="text-center">No</th>
                                <th>No.Reg</th>
                                <th>RM</th>
                                <th>Nama Pasien</th>
                                <th>Tgl Reg</th>
                                <th>Tgl Keluar</th>
                                <th>Jam Reg</th>
                                <th>Jam Keluar</th>
                                <th>Kunjungan</th>
                                <th>No. Urut</th>
                                <th>Print</th>
                                <th>R. Rawat</th>
                                <th>Poli</th>
                                <th>Dokter</th>
                                <th>Tujuan</th>
                                <th>Cara Bayar</th>
                                <th>User</th>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr
                                v-for="(item, index) in rows"
                                :key="item.regno + '-' + index"
                                :class="{
                                    'table-danger': !item.validuser,
                                }"
                            >
                                <td class="text-center">
                                    {{ rowNumber(index) }}
                                </td>
                                <td>{{ show(item.regno) }}</td>
                                <td>{{ show(item.medrec) }}</td>
                                <td>{{ show(item.firstname) }}</td>
                                <td>{{ formatDate(item.regdate) }}</td>
                                <td>{{ formatDate(item.tanggalkeluar) }}</td>
                                <td>{{ formatTime(item.regtime) }}</td>
                                <td>{{ formatTime(item.jamkeluar) }}</td>
                                <td>{{ show(item.kunjungan) }}</td>
                                <td>{{ show(item.nomorurut) }}</td>
                                <td>{{ show(item.prn) }}</td>
                                <td>{{ show(item.nmbangsal) }}</td>
                                <td>{{ show(item.nmpoli) }}</td>
                                <td>{{ show(item.nmdoc) }}</td>
                                <td>{{ show(item.nmtuju) }}</td>
                                <td>{{ show(item.nmcbayar) }}</td>
                                <td>{{ show(item.validuser) }}</td>
                                <td class="text-center">
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-primary"
                                        @click="openEdit(item)"
                                    >
                                        <i class="fa fa-edit"></i>
                                    </button>
                                </td>
                            </tr>

                            <tr v-if="!loading && rows.length === 0">
                                <td
                                    colspan="18"
                                    class="text-center text-muted py-4"
                                >
                                    <i class="fa fa-inbox me-1"></i>
                                    Data tidak ditemukan.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card-footer bg-white">
                <div
                    class="d-flex flex-wrap align-items-center justify-content-between gap-2"
                >
                    <div class="small text-muted">
                        Menampilkan
                        {{ pagination.from || 0 }}
                        -
                        {{ pagination.to || 0 }}
                        dari
                        {{ pagination.total || 0 }}
                        data
                    </div>

                    <div class="btn-group">
                        <button
                            type="button"
                            class="btn btn-sm btn-outline-secondary"
                            :disabled="loading || pagination.current_page <= 1"
                            @click="goPage(pagination.current_page - 1)"
                        >
                            <i class="fa fa-chevron-left"></i>
                        </button>

                        <button
                            type="button"
                            class="btn btn-sm btn-light"
                            disabled
                        >
                            {{ pagination.current_page }}
                            /
                            {{ pagination.last_page }}
                        </button>

                        <button
                            type="button"
                            class="btn btn-sm btn-outline-secondary"
                            :disabled="
                                loading ||
                                pagination.current_page >= pagination.last_page
                            "
                            @click="goPage(pagination.current_page + 1)"
                        >
                            <i class="fa fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="modal" class="custom-modal" @click.self="closeModal">
            <div class="custom-modal-dialog">
                <div class="card border-0 shadow-lg">
                    <div class="card-header bg-primary text-white">
                        <div
                            class="d-flex justify-content-between align-items-center"
                        >
                            <div class="fw-semibold">File Status Keluar</div>

                            <button
                                type="button"
                                class="btn-close btn-close-white"
                                @click="closeModal"
                            ></button>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label">
                                    No. Registrasi
                                </label>
                                <input
                                    v-model="form.noRegno"
                                    type="text"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="col-md-6">
                                <label class="form-label">
                                    No. Rekam Medis
                                </label>
                                <input
                                    v-model="form.noMedrec"
                                    type="text"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="col-12">
                                <label class="form-label"> Nama Pasien </label>
                                <input
                                    v-model="form.nama_pasien"
                                    type="text"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="col-md-6">
                                <label class="form-label">
                                    Tanggal Registrasi
                                </label>
                                <input
                                    v-model="form.no_tanggal"
                                    type="date"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="col-md-6">
                                <label class="form-label">
                                    Jam Registrasi
                                </label>
                                <input
                                    v-model="form.no_jam"
                                    type="text"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="col-12">
                                <label class="form-label fw-semibold">
                                    Status
                                </label>

                                <div class="form-check mb-2">
                                    <input
                                        id="keluar-status-1"
                                        v-model="form.Status"
                                        type="radio"
                                        class="form-check-input"
                                        value="1"
                                    />
                                    <label
                                        class="form-check-label"
                                        for="keluar-status-1"
                                    >
                                        Diambil/Diantar Langsung ke Poli
                                    </label>
                                </div>

                                <div class="form-check mb-2">
                                    <input
                                        id="keluar-status-2"
                                        v-model="form.Status"
                                        type="radio"
                                        class="form-check-input"
                                        value="2"
                                    />
                                    <label
                                        class="form-check-label"
                                        for="keluar-status-2"
                                    >
                                        Diambil/Diantar Langsung ke Rawat Inap
                                    </label>
                                </div>

                                <div class="form-check">
                                    <input
                                        id="keluar-status-3"
                                        v-model="form.Status"
                                        type="radio"
                                        class="form-check-input"
                                        value="3"
                                    />
                                    <label
                                        class="form-check-label"
                                        for="keluar-status-3"
                                    >
                                        Dipinjam
                                    </label>
                                </div>
                            </div>

                            <div class="col-12">
                                <label class="form-label">
                                    Nama Peminjam / Penjamin
                                </label>
                                <input
                                    v-model="form.NmPenjamin"
                                    type="text"
                                    class="form-control"
                                />
                            </div>

                            <div class="col-12">
                                <label class="form-label"> Bagian </label>
                                <input
                                    v-model="form.noBagian"
                                    type="text"
                                    class="form-control"
                                />
                            </div>

                            <div class="col-12">
                                <label class="form-label"> Keterangan </label>
                                <textarea
                                    v-model="form.keterangan"
                                    class="form-control"
                                    rows="3"
                                ></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer bg-white text-end">
                        <button
                            type="button"
                            class="btn btn-secondary me-2"
                            :disabled="saving"
                            @click="closeModal"
                        >
                            Tutup
                        </button>

                        <button
                            type="button"
                            class="btn btn-primary"
                            :disabled="saving"
                            @click="save"
                        >
                            <span
                                v-if="saving"
                                class="spinner-border spinner-border-sm me-1"
                            ></span>
                            <i v-else class="fa fa-save me-1"></i>
                            {{ saving ? "Menyimpan..." : "Simpan" }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FileStatusKeluar",

    data() {
        const today = this.today();

        return {
            loading: false,
            loadingPoli: false,
            saving: false,
            modal: false,
            rows: [],
            poli: [],
            perPage: 25,
            filter: {
                Regno: "",
                Medrec: "",
                Firstname: "",
                Poli: "",
                PoliNama: "",
                date1: today,
                date2: today,
            },
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 25,
                from: null,
                to: null,
                total: 0,
            },
            form: {
                noRegno: "",
                noMedrec: "",
                nama_pasien: "",
                no_tanggal: "",
                no_jam: "",
                Status: "1",
                NmPenjamin: "",
                noBagian: "",
                keterangan: "",
            },
        };
    },

    mounted() {
        this.loadPoli();
        this.loadData();
    },

    methods: {
        today() {
            const date = new Date();
            const offset = date.getTimezoneOffset();
            const local = new Date(date.getTime() - offset * 60000);
            return local.toISOString().substring(0, 10);
        },

        async loadPoli() {
            this.loadingPoli = true;

            try {
                const response = await this.axios.get(
                    "/api/monitoring-file-status/poli"
                );

                this.poli = response.data.data || [];
            } catch (error) {
                this.poli = [];
            } finally {
                this.loadingPoli = false;
            }
        },

        async loadData(page = 1) {
            this.loading = true;

            try {
                const response = await this.axios.get(
                    "/api/monitoring-file-status/file-status-keluar",
                    {
                        params: {
                            ...this.filter,
                            page,
                            per_page: this.perPage,
                        },
                    }
                );

                if (response.data.status !== "success") {
                    throw new Error(
                        response.data.message || "Data gagal dimuat."
                    );
                }

                this.rows = response.data.list.data || [];
                this.pagination = response.data.list;
            } catch (error) {
                this.rows = [];

                this.showError(
                    error.response?.data?.message ||
                        error.message ||
                        "Data gagal dimuat."
                );
            } finally {
                this.loading = false;
            }
        },

        applyFilter() {
            if (
                this.filter.date1 &&
                this.filter.date2 &&
                this.filter.date2 < this.filter.date1
            ) {
                this.showError(
                    "Tanggal sampai tidak boleh lebih kecil dari tanggal mulai."
                );
                return;
            }

            this.loadData(1);
        },

        resetFilter() {
            const today = this.today();

            this.filter = {
                Regno: "",
                Medrec: "",
                Firstname: "",
                Poli: "",
                PoliNama: "",
                date1: today,
                date2: today,
            };

            this.loadData(1);
        },

        onPoliChange() {
            const selected = this.poli.find(
                (item) => String(item.KDPoli) === String(this.filter.Poli)
            );

            this.filter.PoliNama = selected ? selected.NMPoli : "";
        },

        changePerPage() {
            this.loadData(1);
        },

        goPage(page) {
            if (page < 1 || page > this.pagination.last_page || this.loading) {
                return;
            }

            this.loadData(page);
        },

        rowNumber(index) {
            return (
                (this.pagination.current_page - 1) * this.pagination.per_page +
                index +
                1
            );
        },

        openEdit(item) {
            this.form = {
                noRegno: item.regno || "",
                noMedrec: item.medrec || "",
                nama_pasien: item.firstname || "",
                no_tanggal: this.dateInput(item.regdate),
                no_jam: this.formatTime(item.regtime),
                Status: item.nstatus ? String(item.nstatus) : "1",
                NmPenjamin: item.namapeminjam || "",
                noBagian: item.bagian || "",
                keterangan: item.keterangan || "",
            };

            this.modal = true;
        },

        closeModal() {
            if (!this.saving) {
                this.modal = false;
            }
        },

        async save() {
            if (!this.form.noRegno) {
                this.showError("Nomor registrasi tidak ditemukan.");
                return;
            }

            this.saving = true;

            try {
                const response = await this.axios.post(
                    "/api/monitoring-file-status/file-status-keluar",
                    {
                        noRegno: this.form.noRegno,
                        Status: this.form.Status,
                        NmPenjamin: this.form.NmPenjamin,
                        noBagian: this.form.noBagian,
                        keterangan: this.form.keterangan,
                    }
                );

                if (response.data.status !== "success") {
                    throw new Error(
                        response.data.message || "Data gagal disimpan."
                    );
                }

                this.modal = false;

                await this.$swal.fire({
                    title: "Berhasil",
                    text: response.data.message,
                    icon: "success",
                });

                await this.loadData(this.pagination.current_page);
            } catch (error) {
                this.showError(
                    error.response?.data?.message ||
                        error.message ||
                        "Data gagal disimpan."
                );
            } finally {
                this.saving = false;
            }
        },

        printPdf() {
            const query = new URLSearchParams({
                Regno: this.filter.Regno || "",
                Medrec: this.filter.Medrec || "",
                Firstname: this.filter.Firstname || "",
                Poli: this.filter.Poli || "",
                PoliNama: this.filter.PoliNama || "",
                date1: this.filter.date1 || "",
                date2: this.filter.date2 || "",
            });

            window.open(
                `/api/monitoring-file-status/file-status-keluar/pdf?${query.toString()}`,
                "_blank"
            );
        },

        show(value) {
            return value === null || value === undefined || value === ""
                ? "-"
                : value;
        },

        dateInput(value) {
            if (!value) return "";

            return String(value).substring(0, 10);
        },

        formatDate(value) {
            if (!value) return "-";

            const valueString = String(value);

            const match = valueString.match(/^(\d{4})-(\d{2})-(\d{2})/);

            if (match) {
                return `${match[3]}/${match[2]}/${match[1]}`;
            }

            const date = new Date(value);

            if (isNaN(date.getTime())) {
                return valueString;
            }

            return date.toLocaleDateString("id-ID");
        },

        formatTime(value) {
            if (!value) return "-";

            const text = String(value);

            const match = text.match(/(\d{2}):(\d{2})(?::(\d{2}))?/);

            if (!match) {
                return text;
            }

            return `${match[1]}:${match[2]}`;
        },

        showError(message) {
            this.$swal.fire({
                title: "Error",
                text: message,
                icon: "error",
                confirmButtonText: "OK",
            });
        },
    },
};
</script>

<style scoped>
.per-page {
    width: 80px;
}

.loading-overlay {
    position: absolute;
    inset: 0;
    z-index: 20;
    min-height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.78);
}

.table {
    font-size: 13px;
    white-space: nowrap;
}

.custom-modal {
    position: fixed;
    inset: 0;
    z-index: 1055;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.5);
}

.custom-modal-dialog {
    width: 100%;
    max-width: 700px;
    margin: auto;
}
</style>
